const getCookie = name =>
  document.cookie.split(/\s*;\s*/g)
    .map(pair => pair.split(/=/))
    .filter(([key]) => key === name)
    .map(([_, value]) => value)[0];

export default getCookie;